import { Component, Input } from '@angular/core';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { SessionService } from "src/app/session.service";
import { environment } from "src/environments/environment";
import { Router, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserRoleService } from 'src/app/shared/user-role.service';
import { ExecutiveHighlightService } from '../../shared/ExecutiveHighlightService.service';

@Component({
    selector: 'app-dashboard-switcher',
    templateUrl: './dashboard-switcher.component.html',
    styleUrls: ['./dashboard-switcher.component.css'],
    standalone: false
})
export class DashboardSwitcherComponent {
private storage = environment.storage;
dashboards: string[] = [];
plant: any[] = [];
teamMembers: any[] = [];
loginForm: any;
errorMessage: string = "";
@Input() admin_id: number | null = null; 
userRole: number | null = null; // Initialize userRole to null
executiveMembers: any[] = [];
executive: any[] = [];
highlightedExecutiveIndex: number | null = null;
highlightedExecutiveRole: number | null = null;
mode: 'plant' | 'executive' = 'plant';
executiveLinks: any[] = []; // To hold executive links for the selected executive
selectedExecutiveIndex: number | null = null;
currentSiteId: number | null = null;
currentSiteName: string = '';

constructor(private userService: UserManagementService, private router: Router, private sessionService: SessionService, private userRoleService: UserRoleService, private executiveHighlightService: ExecutiveHighlightService) {
    
}

ngOnInit(): void {
    this.fetchUsers();
    this.fetchUsersE();
   this.executiveHighlightService.highlightedIndex$.subscribe(index => {
    this.highlightedExecutiveIndex = index;
  });
  this.executiveHighlightService.highlightedRole$.subscribe(role => {
    this.highlightedExecutiveRole = role;
  });

  const mode = localStorage.getItem('dashboardSwitcherMode');
  if (mode === 'executive') {
    this.mode = 'executive';
    const idx = localStorage.getItem('dashboardSwitcherExecutiveIndex');
    this.selectedExecutiveIndex = idx ? Number(idx) : null;
  } else {
    this.mode = 'plant';
    this.selectedExecutiveIndex = null;
  }

  // Load current site info from localStorage
  this.loadCurrentSiteInfo();
}

loadCurrentSiteInfo() {
  const storedSiteId = localStorage.getItem('currentSiteId');
  const storedSiteName = localStorage.getItem('currentSiteName');
  if (storedSiteId) {
    this.currentSiteId = Number(storedSiteId);
  }
  if (storedSiteName) {
    this.currentSiteName = storedSiteName;
  }
}

isCurrentSite(siteId: number): boolean {
  return this.currentSiteId === siteId;
}

private handleSwitchResponse(response: any): void {
  if (!this.userService.applyAuthenticatedSession(response)) {
    this.errorMessage = response?.message || response?.msg || "Unable to switch user.";
    return;
  }

  this.sessionService.resetSessionTimeout();

  if (response.user.role === 16) {
    this.router.navigate(["/user-management-sites"]).then(() => {});
  } else if (response.user.role === 13) {
    this.router.navigate(["reportlibrary/editreport/process"]);
  } else {
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
  }
}
fetchUsers() {
  // Get admin_user_id from session storage (not localStorage)
  const admin_user_id = Number(sessionStorage.getItem('admin_id'));

  this.userService.getPlants(admin_user_id).subscribe(response => {
    if (response.status === 1) {
      this.plant = response.plants;

      // Dynamically populate teamMembers based on the fetched plants
      this.teamMembers = this.plant.map((plant, index) => {
        const mappedMember = {
          name: `${plant.site_name}`, // Placeholder name
          site_id: plant.site_id,
          user_id: plant.user_id,
          admin_id: plant.admin_user_id,
        };
        return mappedMember;
      });
    } else {
      // handle error
    }
  });
}

fetchUsersE() {
       const admin_user_id = Number(sessionStorage.getItem('admin_id'));
      this.userService.getExecutive(admin_user_id).subscribe(response => {
      if (response.status === 1) {
        this.executive = response.executives;

        // Dynamically populate executiveMembers based on the fetched executives.
        // Sites with no executive_id are left out: there is no account to
        // switch into, so offering them would switch to an undefined user.
        this.executiveMembers = this.executive
          .filter((exec) => exec.executive_id !== null && exec.executive_id !== undefined)
          .map((exec) => ({
            name: `${exec.site_name}`,
            site_id: exec.site_id,
            user_id: exec.executive_id,
            admin_id: exec.admin_user_id,
          }));
      } else {
        // handle error
      }
      });
    }


  isPanelOpen = false;

  togglePanel() {
    this.isPanelOpen = !this.isPanelOpen;
  }
switchToPlantDashboard() {
  const admin_user_id = Number(sessionStorage.getItem('admin_id'));
  this.userService.switchUser(admin_user_id, admin_user_id).subscribe(
    (response: any) => {
      this.handleSwitchResponse(response);
    },
    (error) => {
      // handle error
    }
  );
}

  switchUser(mappedMember: { site_id: number; user_id: number; name?: string }) {
        this.mode = 'plant';
        localStorage.setItem('dashboardSwitcherMode', 'plant');
        localStorage.setItem('currentSiteId', mappedMember.site_id.toString());
        localStorage.setItem('currentSiteName', mappedMember.name || '');
        localStorage.setItem('currentDashboardType', 'plant');
        this.currentSiteId = mappedMember.site_id;
        this.currentSiteName = mappedMember.name || '';
        const adminId = Number(sessionStorage.getItem('admin_id'));
  
        this.userService.switchUser(mappedMember.user_id, adminId).subscribe(
          (response: any) => {
            this.handleSwitchResponse(response);
          },
          (error) => {
            // handle error
          }
        );
      }

      switchExecutive(mappedExecutive: { site_id: number; user_id: number; name?: string }, executive: any, index: number) {
            this.executiveHighlightService.setHighlight(index, 12);
            localStorage.setItem('currentSiteId', mappedExecutive.site_id.toString());
            localStorage.setItem('currentSiteName', mappedExecutive.name || '');
            localStorage.setItem('currentDashboardType', 'executive');
            this.currentSiteId = mappedExecutive.site_id;
            this.currentSiteName = mappedExecutive.name || '';
            const adminId = Number(sessionStorage.getItem('admin_id'));
      
            this.userService.switchUser(mappedExecutive.user_id, adminId).subscribe(
              (response: any) => {
                this.handleSwitchResponse(response);
              },
              (error) => {
                // handle error
              }
            );
          }
}
